module.exports = function(hljs) {
    return {
        disableAutodetect: true
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/highlight.js/lib/languages/plaintext.js
// module id = 566
// module chunks = 27180705640166